// extracted by mini-css-extract-plugin
export default {"Footer":"Footer_Footer__2megN","MapBlock":"Footer_MapBlock__7F+IY","MapLink":"Footer_MapLink__OzQbz"};